import Modal from "./modal";
import VideoPlayer from "./video-player";

class ModalVideo {
    protected buttons = '.program-slider-item.with-trailer, .js-show-modal-video';
    protected videoType = 'youtube';
    protected modal;

    constructor() {
        $(document).on('click', this.buttons, (e) => {
            let url = $(e.currentTarget).data('video');
            let type = $(e.currentTarget).data('videoType');
            let goalEvent =  $(e.currentTarget).data('goal');
            if (typeof goalEvent !== 'undefined') {
                // @ts-ignore
                ym(84987436,'reachGoal', goalEvent);
            }
            if (typeof type !== 'undefined')
                this.videoType = type;

            this.showModal(url);
        });


        $(document).on('click', '#modal-announcement .modal-container-backdrop', this.modalClose.bind(this));
        $(document).keyup((e) => {
            if (e.keyCode === 27 && this.modal) this.modalClose();
        });

      /*  window.addEventListener("message", (event) => {
            //alert(event.data)
            if (event.origin === 'https://playercdn.cdnvideo.ru' && event.data.length > 0) {
                console.log(event)
                this.modalClose();
                let doc = document as any;
                let isInFullScreen = (doc.fullscreenElement && true) || (doc.webkitFullscreenElement && true) || (doc.mozFullScreenElement && true) || (doc.msFullscreenElement && true);

                if (isInFullScreen) {
                    if (doc.exitFullscreen) {
                        doc.exitFullscreen();
                    } else if (doc.webkitExitFullscreen) {
                        doc.webkitExitFullscreen();
                    } else if (doc.mozCancelFullScreen) {
                        doc.mozCancelFullScreen();
                    } else if (doc.msExitFullscreen) {
                        doc.msExitFullscreen();
                    }
                }
            }
        });*/
    }

    showModal(url: string) {
        if (url === '')
            return;

        let cdnFileCheck = url.match('##(.*?)##');
        if (cdnFileCheck !== null) {
            let cdnFileName = cdnFileCheck[1];
            url = 'https://playercdn.cdnvideo.ru/aloha/players/kinochannel_player1.html?account=kinochannel&autoplay=true&source=https://video.platformcraft.ru/vod/'+ cdnFileName +'.mp4/playlist.m3u8&poster=https://kinochannel-cache.cdnvideo.ru/kinochannel/'+ cdnFileName +'.jpg';
            this.videoType = 'cdn';
        }
        let video = new VideoPlayer({
            url: url,
            type: this.videoType,
            onEnded: () => {
                this.modalClose();
            }
        });
        this.modal = new Modal({
            id: 'modal-announcement',
            onAfterHide: (e) => {
                e.destroy();
                $('body').removeClass('modal-announcement-open')
            },
            onAfterShow: () => {
                video.initPlay();
                $('body').addClass('modal-announcement-open')
            }
        }, video.render());


        this.modal.show();
    }

    modalClose() {
        this.modal.hide();
    }
}

export default ModalVideo;
